var moduleMap = {
	"./OpenEvents": () => {
		return __webpack_require__.e(137).then(() => (() => ((__webpack_require__(54137)))));
	},
	"./ClosedEvents": () => {
		return __webpack_require__.e(705).then(() => (() => ((__webpack_require__(64705)))));
	},
	"./EventTypes": () => {
		return __webpack_require__.e(657).then(() => (() => ((__webpack_require__(76657)))));
	},
	"./EventMenuItems": () => {
		return __webpack_require__.e(813).then(() => (() => ((__webpack_require__(34813)))));
	},
	"./EventTypeProvider": () => {
		return __webpack_require__.e(117).then(() => (() => ((__webpack_require__(50117)))));
	},
	"./AOGParts": () => {
		return __webpack_require__.e(468).then(() => (() => ((__webpack_require__(61468)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});